<template>
  <div>
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Create New Markets</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-alert
          v-model="alert.show"
          :dismissible="alert.dismissible"
          :type="alert.type"
          transition="fade-transition"
          class="ma-4"
        >
          {{ alert.text }}
        </v-alert>
        <v-form ref="form" v-model="form" class="px-4 pt-4">
          <p>Select 1 or multiple dates.</p>

          <v-date-picker
            v-model="formData.dates"
            multiple
            full-width
            :min="new Date().toISOString()"
            :allowed-dates="allowedDates"
            @update:picker-date="pickerUpdate($event)"
          ></v-date-picker>
        </v-form>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary darken-1"
            text
            @click.stop="submitForm()"
            :disabled="formData.dates.length == 0"
            :loading="isSaveBtnLoading"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="isSaveBtnLoading" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import datePickerMixin from "../js/datePickerMixin";

export default {
  data: () => ({
    dialog: "",
    formData: {
      dates: []
    },
    isSaveBtnLoading: false,
    isCloseBtnDisabled: false,
    alert: {
      show: false,
      text: "",
      type: "success",
      dismissible: true
    },
    form: false,
    rules: {
      password: v =>
        (v || "").match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
        "Password must contain an upper case letter, a numeric character, and a special character",
      required: v => !!v || "This field is required",
      email: v => /.+@.+/.test(v) || "Please enter a valid email",
      maxLength: (len, v) =>
        (v || "").length <= len || `Invalid character length, maximum ${len}`
    },
    alert: {
      show: false,
      text: "",
      type: "info",
      dismissible: true
    },
    setupTimeMenu: false,
    stallholderFilter: (item, queryText, itemText) => {
      let searchString = `${item.stall_name} ${item.first_name} ${
        item.last_name
      } ${item.email}`;
      return searchString.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
    }
  }),
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    selectedDates: {
      type: Array,
      required: false
    }
  },
  mixins: [datePickerMixin],
  watch: {
    dialogVisible(newData, oldData) {
      if (newData) {
        if (this.selectedDates)
          this.formData = Object.assign({}, { dates: this.selectedDates });
        else this.formData = { dates: [] };
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
      this.formdata = {};
      this.isSaveBtnLoading = false;
      this.resetAlert();
    },
    submitForm() {
      this.resetAlert();

      if (this.$refs.form.validate()) this.createMarkets();
    },
    createMarkets() {
      this.savingDialog = true;
      let self = this;
      this.isSaveBtnLoading = true;

      axios({
        method: "POST",
        url: `/wisdom-markets/v1/markets/batch-create/`,
        headers: {
          Authorization: `Bearer ${this.$store.state.accessToken}`
        },
        data: this.formData
      })
        .then(response => {
          console.log("saved", response);
          this.isSaveBtnLoading = false;
          this.savingDialog = false;

          if (response.data.errors) {
            self.showAlert(
              "warning",
              `Created: 
                ${response.data.data.map(m => m.market_date)}. Errors: ${
                response.data.errors
              }`
            );
          } else {
            self.showAlert(
              "success",
              `Created: ${response.data.data.map(m => m.market_date)}`
            );
          }

          this.formData = { dates: [] };
          this.$emit("create", response.data.data);
        })
        .catch(function(error, data) {
          self.isSaveBtnLoading = false;
          self.savingDialog = false;
          self.showAlert("error", "Error! " + error.response.data.message);
        });
    },
    showAlert(type, text) {
      this.alert.show = true;
      this.alert.text = text;
      this.alert.type = type;
    },
    resetAlert() {
      //and reset
      this.alert = {
        show: false,
        text: "",
        type: "info",
        dismissible: true
      };
    },
    allowedDates(val) {
      // override the default mixin func, as now we need the inverse
      return !this.$store.state.availablePickerMarketsDates.includes(val);
    }
  },
  computed: {
    //
    isDialogVisible() {
      if (this.dialog != this.dialogVisible) {
        return this.dialogVisible;
      } else {
        return this.dialog;
      }
    }
  },
  mounted() {}
};
</script>
